import Vue from "vue";
//导入需要全局暴露的过滤器
import filters from "./filter";
//全局注册过滤器
Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});